import Validation from "@/classes/global/Validation";
import ValidationBase from "@/classes/global/ValidationBase";

export default class PreJobRoadBookingValidation extends ValidationBase {

    constructor() {

        super();

        this.placeOfReceipt = new Validation();
        this.originPort = new Validation();
        this.destinationPort = new Validation();
        this.finalDestination = new Validation();
        this.remarks = new Validation();
        this.estimatedPickupDate = new Validation();
        this.estimatedPickupTime = new Validation();
        this.estimatedDepartureTime = new Validation();
        this.estimatedDeliveryDate = new Validation();
        this.estimatedArrivalDate = new Validation();
        this.estimatedArrivalTime = new Validation();
        this.estimatedDepartureDate = new Validation();
        this.estimatedDeliveryTime = new Validation();
        this.currency = new Validation();
        this.shipmentValue = new Validation();
        this.serviceType = new Validation();
        this.terms = new Validation();
        this.totalPieces = new Validation();
        this.totalWeight = new Validation();
        this.customerRef = new Validation();
        this.sealNumber = new Validation();
        this.commodity = new Validation();
    }

}
